import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { INavItem } from "../../layouts/generalLayout/components/navItems";

export interface IMenuState {
  mainNavItem?: INavItem;
  openItem: string[];
  globalNavItems: any[];
  defaultId: string;
  openComponent: string;
  drawerOpen: boolean;
  componentDrawerOpen: boolean;
  openModal: ((truth: boolean) => void) | null;
}

const initialState = {
  openItem: [""],
  globalNavItems: [],
  defaultId: "",
  openComponent: "buttons",
  drawerOpen: false,
  componentDrawerOpen: true,
  openModal: null,
} as IMenuState;

const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    activeItem(state, action) {
      state.openItem = action.payload.openItem;
    },
    activeComponent(state, action) {
      state.openComponent = action.payload.openComponent;
    },

    setGlobalNavItems(state: IMenuState, action: PayloadAction<any[]>) {
      state.globalNavItems = action.payload;
    },

    openDrawer(state, action) {
      state.drawerOpen = action.payload.drawerOpen;
    },

    openComponentDrawer(state, action) {
      state.componentDrawerOpen = action.payload.componentDrawerOpen;
    },
    setModalCloser(state, action) {
      state.openModal = action.payload;
    },
    runModalCloser(state) {
      let func = state.openModal;
      if (func) {
        func(false);
      }
      state.openModal = null;
    },

    setMainNavItem(state, action: PayloadAction<INavItem | undefined>) {
      state.mainNavItem = action?.payload ?? undefined;
    },
  },
});

export const {
  activeItem,
  setGlobalNavItems,
  activeComponent,
  openDrawer,
  openComponentDrawer,
  runModalCloser,
  setModalCloser,
  setMainNavItem,
} = menuSlice.actions;

export default menuSlice.reducer;
